module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03e.f25fe648.jpg";